import { Link } from 'react-router-dom';

export default function Hero() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/113bace4f598e221e82f1b1df673c3a4.jpg"
          alt="Students studying abroad"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-900/95 via-slate-900/85 to-slate-900/40"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 py-24 sm:py-32 grid lg:grid-cols-2 gap-12 items-center">
        <div className="text-white space-y-6 sm:space-y-8">
          <div className="space-y-4">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
              Transform Your Future Through{' '}
              <span className="text-emerald-400">Global Education</span>
            </h2>
            <p className="text-base sm:text-lg text-gray-300 leading-relaxed">
              Personalized guidance from application to arrival. We make studying abroad simple, transparent, and achievable.
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4">
            <Link
              to="/booking"
              className="px-8 py-4 bg-emerald-500 text-white font-medium rounded-full hover:bg-emerald-600 transition-all hover:scale-105 whitespace-nowrap cursor-pointer text-center"
            >
              Start Your Journey
            </Link>
            <button
              onClick={() => scrollToSection('destinations')}
              className="px-8 py-4 border-2 border-white text-white font-medium rounded-full hover:bg-white hover:text-slate-900 transition-all whitespace-nowrap cursor-pointer"
            >
              Explore Destinations
            </button>
          </div>

          <div className="pt-4 sm:pt-8 flex items-center gap-4">
            <div className="bg-emerald-500/20 backdrop-blur-sm px-6 py-4 rounded-2xl border border-emerald-400/30">
              <div className="flex items-center gap-3">
                <i className="ri-global-line text-3xl text-emerald-400"></i>
                <div>
                  <p className="text-2xl font-bold">500+</p>
                  <p className="text-sm text-gray-300">Students Placed Globally</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
